module.exports = "<ion-item class=\"item-text-wrap\"\n          ng-class=\"{'item-icon-right': $ctrl.iconRight != null}\">\n\n    <h3 class=\"padding-bottom\">\n        {{$ctrl.vehicle.tagNumber | uppercase}}\n    </h3>\n\n    <div class=\"row row-condensed text-light\">\n        <div class=\"col\">\n            <i class=\"icon-customer\"></i> {{$ctrl.vehicle.customer.title}} {{$ctrl.vehicle.customer.name}}\n        </div>\n    </div>\n\n    <i ng-if=\"::$ctrl.iconRight\" class=\"icon\" ng-class=\"$ctrl.iconRight\"></i>\n</ion-item>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/vehicle-item/vehicle-item.html
// module id = 888
// module chunks = 0